import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { useValuesStore } from '../stores/useValuesStore.js';
export const valueSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string(),
    category: z.string(),
    synonyms: z.array(z.string()),
    relatedAntiValues: z.array(z.string()),
});
export const antiValueSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string(),
    pairsWith: z.array(z.string()),
    notes: z.string().nullable(),
});
const valuesListResponseSchema = z.array(valueSchema);
const antiValuesListResponseSchema = z.array(antiValueSchema);
export const useGetValues = (request, autoFetch = true) => {
    const { setValues } = useValuesStore();
    return useQuery({
        queryKey: ['values'],
        queryFn: async () => {
            const response = await request({ url: '/core-values', method: 'GET' }, valuesListResponseSchema);
            if (response?.data) {
                setValues(response.data);
            }
            return response;
        },
        enabled: autoFetch,
    });
};
export const useGetAntiValues = (request, autoFetch = true) => {
    const { setAntiValues } = useValuesStore();
    return useQuery({
        queryKey: ['anti-values'],
        queryFn: async () => {
            const response = await request({ url: '/core-values/anti-values', method: 'GET' }, antiValuesListResponseSchema);
            if (response?.data) {
                setAntiValues(response.data);
            }
            return response;
        },
        enabled: autoFetch,
    });
};
